export class Permission {
    public id:number|null;
    public name:string;
    public role_id:number|null;

    constructor(data:PermissionData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.name = "";
            this.role_id = null;
        }
        else
        {
            this.id = data.id;
            this.name = data.name;
            this.role_id = data.role_id;
        }
    }

    public serializeData(): PermissionData {
        return {
            id: this.id,
            name: this.name,
            role_id: this.role_id,
        };
    }
}

export type PermissionData = {
    id:number|null;
    name:string;
    role_id:number|null;
}
